import { FC, useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../..";
import { getEnv } from "../../../../../AppConfigs";
import { Routes } from "../../../../../AppRoutes";
import { Icon } from "../../../../../components/icon";
import { ProcessContextProvider, ProcessContextType } from "../../../process-context";
import ItRepairToolInformation from "./information";
import ItRepairToolProgress from "./progress";
import { useUpdateRTR } from "../hooks/use-update-RTR";
import { useEmployee, useUser } from "../../../../../hook";
import { useDetailsRTR } from "../hooks/use-details-RTR";
import { Spin } from "antd";
import { eApproveTitleCode } from "../../../../../constants/bizTitle";

export type ExtraStateContext = {
  approverOptions: any[];
  refetch: () => void;
};

export const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REPAIR_REQUEST_URL");

export const repairITToolDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [comment, setComment] = useState("");
  const { updateRTRequest } = useUpdateRTR();
  const { email } = useUser();
  const { data: itRepairToolRequest, isLoading, isPin: hasPin, approvalStep, approvalType } = useDetailsRTR();
  const { getApproverOptions } = useEmployee();

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!itRepairToolRequest) return;
        const pins: any[] = itRepairToolRequest.fields.ePins ? JSON.parse(itRepairToolRequest.fields.ePins) : [];
        const index = pins.findIndex((pin: string) => pin === email?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(email?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };

        updateRTRequest(
          { id: itRepairToolRequest.id, body: fields },
          { successText: hasPin ? "Bỏ ghim thành công" : "Ghim thành công" },
        );
      } catch (error) {
        console.log(error);
      }
    },
    [email, hasPin, itRepairToolRequest, updateRTRequest],
  );

  const ctx = useMemo<ProcessContextType<ExtraStateContext>>(
    () => ({
      Request: itRepairToolRequest,
      approvalStep,
      approvalType,
      comment,
      approverOptions: !itRepairToolRequest
        ? []
        : getApproverOptions({
            eDepCodes: [itRepairToolRequest?.fields?.eDepartmentID],
            eBizTitleCodes: eApproveTitleCode.split(","),
          }),
      setComment,
      refetch: () => null,
      currentUser: email,
      updatePin: handleUpdatePin,
      isPin: () => hasPin,
    }),
    [itRepairToolRequest, approvalStep, approvalType, comment, getApproverOptions, email, handleUpdatePin, hasPin],
  );

  if (isLoading) return <Spin />;

  const handleGoBack = () => {
    history.push(Routes.procedureRepairTools.path);
  };

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Yêu Cầu Duyệt"}
        </div>
      </div>

      <ProcessContextProvider context={ctx}>
        <ItRepairToolProgress />
        <ItRepairToolInformation />
      </ProcessContextProvider>
    </div>
  );
});
